module.exports = __webpack_public_path__ + "static/media/feather.a940fe89.ttf";